import type {ActionResponse, AnyObject, Exemplar, ExemplarIdentifierRequest, ExemplarRequest, ViewableExemplar} from 'src/typings';
import {transferify} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class ExemplarDataService {
    public static readonly serviceName = 'exemplarDataService';

    private static readonly EXEMPLARS_ROUTE = 'exemplars';
    private static readonly EXEMPLARS_DELETE_ROUTE = 'exemplars/delete';
    private static readonly EXEMPLARS_DISCARDION_ROUTE = 'exemplars/discard';
    private static readonly EXEMPLARS_RESTORATION_ROUTE = 'exemplars/restore';
    private static readonly EXEMPLARS_SEQUENCES_ROUTE = 'exemplars/sequences';
    private static readonly EXEMPLARS_IDENTIFIERS_ROUTE = 'exemplars/identifiers';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async query(params: AnyObject & {viewable: false}): Promise<Exemplar[]>
    public async query(params: AnyObject & {viewable: true}): Promise<ViewableExemplar[]>
    @ngAsync()
    public async query(params: AnyObject): Promise<Exemplar[] | ViewableExemplar[]> {
        return this.ajaxService
            .createRequest(ExemplarDataService.EXEMPLARS_ROUTE)
            .get(params);
    }

    @ngAsync()
    public async getById(exemplarId: number): Promise<Exemplar> {
        return this.ajaxService
            .createRequest(`${ExemplarDataService.EXEMPLARS_ROUTE}/${exemplarId}`)
            .get();
    }

    @ngAsync()
    public async save(exemplarRequest: ExemplarRequest): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(ExemplarDataService.EXEMPLARS_ROUTE)
            .post(transferify(exemplarRequest, false));
    }

    @ngAsync()
    public async delete(exemplars: Exemplar[]): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(ExemplarDataService.EXEMPLARS_DELETE_ROUTE)
            .post(transferify({exemplars}));
    }

    @ngAsync()
    public async discard(exemplarId: number): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(ExemplarDataService.EXEMPLARS_DISCARDION_ROUTE)
            .post({exemplar: exemplarId});
    }

    @ngAsync()
    public async restore(exemplarId: number): Promise<ActionResponse> {
        return this.ajaxService
            .createRequest(ExemplarDataService.EXEMPLARS_RESTORATION_ROUTE)
            .post({exemplar: exemplarId});
    }

    @ngAsync()
    public async getSequences(property: string, currentValue: string, formModel: AnyObject): Promise<string[]> {
        return this.ajaxService
            .createRequest(`${ExemplarDataService.EXEMPLARS_SEQUENCES_ROUTE}/${property}`)
            .post({exemplarRequest: transferify(formModel), currentValue});
    }

    @ngAsync()
    public async getPrototypeOfExemplarRequestIdentifiers(exemplarRequest: ExemplarRequest): Promise<ExemplarIdentifierRequest> {
        return this.ajaxService
            .createRequest(`${ExemplarDataService.EXEMPLARS_IDENTIFIERS_ROUTE}`)
            .post(transferify(exemplarRequest));
    }

}
